module.exports = __webpack_public_path__ + "static/banner-left-img-1-f2f8557a2f101f48f9c0beecfee35a65.png";